// src/data/products.js

// Import your product images
import torqueOriginalImg from '../Images/original.png';
import productImage from '../Images/product _image.png';

// Create and export the array of product objects
export const products = [
  {
    id: 1,
    name: 'Torque Masala Cola',
    description: 'The classic formula for maximum power.',
    price: '₹40',
    image: productImage,
  }
  // To add a new product, just add a new object here!
];